import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';


const NAV_LINKS = [
  { to: '/admin/market/dashboard', label: 'Dashboard' },
  { to: '/admin/market/loans', label: 'Loans' },
  { to: '/admin/market/investors', label: 'Investors' },
  { to: '/admin/market/funding', label: 'Funding' },
];

export default function MarketNavbar() {
  const navigate = useNavigate();

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('doorly_admin_token');
    localStorage.removeItem('doorly_admin_user');
    localStorage.removeItem('doorly_admin_force_pw');
    navigate('/admin/login');
  };

  const navLinkStyle = ({ isActive }) => ({
    fontSize: '14px',
    fontWeight: isActive ? '600' : '500',
    color: isActive ? '#111111' : '#374151',
    textDecoration: 'none',
    padding: '6px 12px',
    borderRadius: '8px',
    backgroundColor: isActive ? '#fffd5b' : 'transparent',
    transition: 'all 0.15s',
    whiteSpace: 'nowrap',
  });

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: '64px',
        backgroundColor: '#ffffff', borderBottom: '1px solid #e5e7eb',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)', zIndex: 1000,
        display: 'flex', alignItems: 'center', padding: '0 24px', gap: '24px',
      }}>
        {/* Logo + Market label */}
        <NavLink to="/admin/market/dashboard" style={{ textDecoration: 'none', flexShrink: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img src="/doorly_logo_black.png" alt="Doorly" style={{ height: '32px', width: 'auto' }} />
          <span style={{
            fontSize: '11px', fontWeight: '700', color: '#111111',
            backgroundColor: '#fffd5b', padding: '2px 7px', borderRadius: '5px',
            letterSpacing: '0.04em', textTransform: 'uppercase',
          }}>Market</span>
        </NavLink>

        {/* Desktop Nav Links */}
        <div className="market-nav-links" style={{ display: 'flex', gap: '4px', flex: 1, justifyContent: 'center' }}>
          {NAV_LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} style={navLinkStyle}>{link.label}</NavLink>
          ))}
        </div>

        {/* Right side */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          {/* DoorlyDesk CTA */}
          <button
            onClick={() => navigate('/admin/dashboard')}
            style={{
              padding: '7px 16px', background: '#3a6ad9', color: '#ffffff',
              border: 'none', borderRadius: '8px', cursor: 'pointer',
              fontSize: '13px', fontWeight: '600', display: 'inline-flex', alignItems: 'center',
            }}
          >
            DoorlyDesk
          </button>

          {/* Mobile Hamburger */}
          <button
            className="market-hamburger"
            onClick={() => setShowMobileMenu((v) => !v)}
            style={{ display: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: '8px' }}
          >
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#374151" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {showMobileMenu && (
        <div style={{
          position: 'fixed', top: '64px', left: 0, right: 0,
          backgroundColor: '#fff', borderBottom: '1px solid #e5e7eb',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 999,
          padding: '12px 16px',
        }}>
          {NAV_LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} onClick={() => setShowMobileMenu(false)}
              style={({ isActive }) => ({
                display: 'block', padding: '10px 12px', borderRadius: '8px',
                color: isActive ? '#111111' : '#374151', fontWeight: isActive ? '600' : '500',
                fontSize: '14px', textDecoration: 'none', marginBottom: '2px',
                backgroundColor: isActive ? '#fffd5b' : 'transparent',
              })}
            >{link.label}</NavLink>
          ))}
        </div>
      )}

      {/* Logout Confirm */}
      {showLogoutConfirm && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '28px', width: '340px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
            <h3 style={{ fontWeight: '700', fontSize: '16px', color: '#111827', marginBottom: '8px' }}>Sign out?</h3>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '20px' }}>You will be redirected to the login page.</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowLogoutConfirm(false)} style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e5e7eb', background: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#374151' }}>Cancel</button>
              <button onClick={handleLogout} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', background: '#ff082f', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}>Sign Out</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .market-nav-links { display: none !important; }
          .market-hamburger { display: flex !important; }
        }
      `}</style>
    </>
  );
}
